import { standardChartColors, comparisonChartColors, relatedChartColors } from 'ui/theme';
import { METER_CHART_VARIANTS } from '../types';

const chartColorPalette = {
  [METER_CHART_VARIANTS.COMPARISON]: comparisonChartColors,
  [METER_CHART_VARIANTS.DEFAULT]: standardChartColors,
  [METER_CHART_VARIANTS.RELATED_PURPLE]: relatedChartColors.purplePalette,
  [METER_CHART_VARIANTS.RELATED_BLUE]: relatedChartColors.bluePalette,
  [METER_CHART_VARIANTS.RELATED_GREEN]: relatedChartColors.greenPalette,
};

export const useDefaultColorPalette = (variant: METER_CHART_VARIANTS): string[] => {
  const defaultColorPalette = chartColorPalette[variant];
  return Object.values(defaultColorPalette);
};
